import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-determinar-procedencia-fraude',
  templateUrl: './determinar-procedencia-fraude.component.html',
  styleUrls: ['./determinar-procedencia-fraude.component.scss'],
})
export class DeterminarProcedenciaFraudeComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };
  procede;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.procede = values ? values.procedencia : false;
    this.form = this.fb.group({
      procedencia: [values ? values.procedencia : false, [Validators.required]],
      fraude: [values ? values.fraude : false, [Validators.required]],
      // doble: [values ? values.doble : false, [Validators.required]],
    });
  }

  changeValidators(v) {
    if (v == 'Procedencia') {
      this.form.controls.fraude.setValidators([Validators.required]);
      // this.form.controls.doble.setValidators([Validators.required]);
    } else {
      this.form.controls.fraude.setValidators([]);
      // this.form.controls.doble.setValidators([]);
    }
  }
}
